import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { isAuthenticated } from '@/lib/auth-store'
import { AppLayout } from '@/components/AppLayout'

export const Route = createFileRoute('/sequences')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: SequencesLayout,
})

function SequencesLayout() {
  return (
    <AppLayout title="Sequences">
      <Outlet />
    </AppLayout>
  )
}
